import { useEffect } from "react";
import { FieldErrors, FieldValues, UseFormRegister, UseFormSetValue, UseFormWatch } from "react-hook-form";
import "./form-style.scss";

const ALLOWED_FILE_EXTENSIONS = [".png", ".jpg", ".jpeg", ".webp", ".csv", ".xlsx", ".pdf"];

interface AttachmentBoxProps {
  register: UseFormRegister<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  id: string;
  required?: boolean | string;
  setValue: UseFormSetValue<FieldValues>;
  errors: FieldErrors<FieldValues>;
}

const AttachmentBox: React.FC<AttachmentBoxProps> = ({
  register,
  watch,
  id,
  required = false,
  setValue,
  errors = {},
}) => {
  // console.log("errors", errors);
  const error = id in errors;
  const error_message = errors?.[id]?.message ?? "";

  const files: File[] = watch(id);
  function addFiles(value: React.ChangeEvent<HTMLInputElement>) {
    if (value.target.files) {
      setValue(id, [...files, ...Array.from(value.target.files)]);
    }
  }
  function handleRemoveFiles(index: number) {
    const _filteredFiles = [...files];
    _filteredFiles.splice(index, 1);
    setValue(id, _filteredFiles);
  }

  function isFieldValidated(_: any, form_values: any) {
    const value = form_values?.[id] ?? [];
    const number_of_files = value?.length;
    if (required && number_of_files === 0) {
      return "Atleast one attachment must be selected";
    }
    return true;
  }

  useEffect(() => {
    register(id, {
      required: required ? "Atleast one attachment must be added" : false,
      validate: (value, formValues) => {
        return isFieldValidated(value, formValues);
      },
    });
  }, []);

  return (
    <>
      <div className="file-input">
        <div>Add Attachments</div>
        <input
          type="file"
          id="file"
          accept={ALLOWED_FILE_EXTENSIONS.join(", ")}
          className="file"
          onChange={addFiles}
          multiple
        />
        <label htmlFor="file">SELECT FILE</label>
        {files?.map((file, index) => (
          <div className="flex items-center gap-3" key={file.name + index}>
            <div className="cursor-pointer" onClick={() => handleRemoveFiles(index)}>
              X
            </div>
            <div>{file.name}</div>
          </div>
        ))}
        {error && <div className="error-message">{error_message}</div>}
      </div>
    </>
  );
};

export default AttachmentBox;
